// Terms of Service and Privacy Policy are currently published as the same document.
// Kept in one place so the login modal and the cookie banner cannot drift apart.
export const TERMS_OF_SERVICE_URL =
  'https://docs.google.com/document/d/e/2PACX-1vTC4hPHpMdmyhSaVEkcf7t5IALiOxzTDIyF_0oVxkFzuWTeZd_xalJX-4jjTrvje51grw5SmFyMGOkw/pub';

export const PRIVACY_POLICY_URL = TERMS_OF_SERVICE_URL;

// Bumping this re-collects login consent for the new policy. Must match the backend's
// expected version so a stored acceptance is recognised as current.
export const TERMS_VERSION = 'v1';
